<template>
<div>
    <div class="vx-row">
        <!--FIN TIPOS PAGOS FACTURACION-->
        <!--FILE-->
        <div class="vx-col w-full mb-6">
            <p class="ml-2">Logo:</p>
            <p class="mt-1"></p>
            <div class="box-input" v-if="attachmentArray.length == 0 && ifSaveImagen == false">
                <div class=" box upload-container">
                    <input type="file" name="fileEmpresa" id="fileEmpresa" v-on:change="uploadFiles" />
                </div>
                <br>
            </div>
            <!--BASE-->
            <div class="box-input" v-if="attachmentArray.length == 0 && ifSaveImagen == true">
                <div class="flex" style="justify-content: center;">
                    <div class="flex" style="flex-direction: column;">
                        <img id="img1" width="200" class="img-responsive mb-2 ml-1" :src="$data_book+'archivos/'+carpeta+'/'+imgOld" style="border-radius: 5px;margin: 0 auto;">
                        <small class="mt-1 ml-2">{{ imgOld }}</small>
                    </div>
                    <vs-button radius type="line" @click="ifSaveImagen = false;" class="ml-2 mt-4" color="danger" icon="delete"></vs-button>
                </div>
            </div>
            <!--LOCAL-->
            <div class="flex" style="margin-top: -10px;" v-if="attachmentArray.length > 0">
                <div class="flex" v-for="(tr,key) in attachmentArray" :key="key" style="margin: 0 auto;">
                    <div class="flex" style="flex-direction: column;">
                        <img id="img1" v-if="tr.tipo == 'img'" width="200" class="img-responsive mb-2 ml-1" v-bind:src="tr.img" style="border-radius: 5px;margin: 0 auto;">
                        <img v-else style="width: 200px;" src="@/assets/images/file-icons/doc.png" />
                        <small class="mt-1 ml-2">{{ tr.name }}</small>
                    </div>
                    <vs-button radius type="line" @click="removeItemFromArr(attachmentArray,tr)" class="ml-2 mt-4" color="danger" icon="delete"></vs-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

  
<script>
import vSelect from 'vue-select'
import axios from 'axios'
export default {
    components: {
        vSelect,
    },
    data() {
        return {
            //VARIABLES IMAGEN
            attachmentArray: [],
            tipoFile: '',
            ifSaveImagen: false,
            imgOld: '',
            ifImagenBd: false,
            //FIN VARIABLES IMAGEN
        }
    },
    props: {
        modelName: {
            type: String,
            required: true
        },
        id: {
            type: Number,
            default: 0
        },
        ObjectPadre: {
            type: Object,
            default: function () {
                return {}
            }
        },
        carpeta: {
            type: String,
            default: ''
        },
    },
    created() {
        let me = this;
    },
    mounted() {
        let me = this;
        me.attachmentArray = []
        if (me.id > 0) {
            me.imgOld = me.ObjectPadre.url
            if (me.imgOld) {
                me.ifSaveImagen = true
                me.ifImagenBd = true
            }
        } else {
            me.ifSaveImagen = false
        }
    },
    watch: {
        ObjectPadre(results) {
            this.ObjectPadre = results
        },
    },
    methods: {
        removeItemFromArr(arr, item) {
            let me = this;
            const i = arr.indexOf(item)
            arr.splice(i, 1)
            document.getElementById("fileEmpresa").value = ''
        },
        uploadFiles(event) {
            let me = this;
            me.attachmentArray = []
            var archivo = document.getElementById("fileEmpresa").files[0];
            me.tipoFile = ""
            if (archivo.type == "image/png" || archivo.type == "image/gif" || archivo.type == "image/jpeg" || archivo.type == "image/jpg") me.tipoFile = "img"
            else me.tipoFile = "other"
            var reader = new FileReader();
            if (me) {
                reader.readAsDataURL(archivo);
                reader.onloadend = function () {
                    var cal = new Object();
                    cal.file = archivo
                    cal.img = reader.result
                    cal.tipo = me.tipoFile
                    cal.name = archivo.name
                    me.attachmentArray.push(cal)
                }
            }
            const file = event.target.files[0];
            this.$emit('input', file);
        },
    }
}
</script>
  
<style scoped>
.box-input {}

.upload-container {
    position: relative
}

.upload-container input {
    border: 1px solid #92b0b3;
    background: #217bc5;
    outline: 2px dashed #92b0b3;
    outline-offset: -10px;
    padding: 100px 0px 100px 130px;
    width: 100%;
    color: white;
}

.upload-container input:hover {
    background: #2c78cf
}

.upload-container:before {
    position: absolute;
    bottom: 50px;
    left: 23%;
    content: " Seleccione un archivo o arrastre aqui ";
    color: #f1f9fa;
    font-weight: 900
}

.upload-btn {
    margin-left: 300px;
    padding: 7px 20px
}
</style>
